import React from 'react'
import Constants from '../../constants';
export const ActionItemStatus = props => {
    const key = Object.keys(Constants.Enums.ActionStatus).find(key => Constants.Enums.ActionStatus[key] == props.value);
    return <>{key}</>;
}